import React, { Component } from 'react'
import { Score } from '@app/constants'

class ProgressBar extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { statistics } = this.props;
    const objects = _.values(statistics.objects);
    const right = _.countBy(objects, 'answer.score')[Score.max] || 0;
    const percentage = right * 100 / objects.length;

    return <ProgressBarWrapper percentage={percentage} />
  }
}

const ProgressBarWrapper = (props) => {
  return (
    <div className="progress-bar">
      <Filler percentage={Math.round(props.percentage)} />
    </div>
  )
}

const Filler = (props) => {
  return (
    <div className="progress-bar__map" style={{ width: `${props.percentage}%` }}>
      <div className="progress-bar__indicator">
        {props.percentage}%
      </div>
    </div>
  )
}

export default ProgressBar;
